import React from "react";
import {Button, Modal} from "react-bootstrap";


export const ShowImportErrors = ({
                                     show,
                                     handleClose, errorsToShow,
                                 }) => {



    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title> </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <table className={'noRounded'} style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                    <tr>
                        <th style={{ border: '1px solid #ccc', padding: '4px' }}> Campo</th>
                        <th style={{ border: '1px solid #ccc', padding: '4px' }}>Messaggio</th>
                    </tr>
                    </thead>
                    <tbody>
                    {errorsToShow && Object.entries(errorsToShow).map(([field, messages]) => (
                        <tr key={field}>
                            <td style={{ border: '1px solid #ccc', padding: '4px'}}>{field}</td>
                            <td style={{ border: '1px solid #ccc', padding: '4px' }}>
                                {messages }
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annulla
                </Button>

            </Modal.Footer>
        </Modal>
    );
};
